import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormAssessmentTeamSummary } from "../Models/Forms/IFormAssessmentTeamSummary";

@Injectable()
export class FormAssessmentTeamSummaryService extends BaseService {
  _baseUrl: string = "";


  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }
  
  getFormAssessmentTeamSummary(id: number) {
    return this._http.get(this._baseUrl + "api/FormAssessmentTeamSummary/" + id)
      .map((response: IFormAssessmentTeamSummary) => response as IFormAssessmentTeamSummary)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormAssessmentTeamSummary/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  insertUpdateFormAssessmentTeamSummary(formAssessmentTeamSummaryDetails: IFormAssessmentTeamSummary) {
    return this._http.post(this._baseUrl + 'api/FormAssessmentTeamSummary', formAssessmentTeamSummaryDetails)
      .map((response: IFormAssessmentTeamSummary) => response as IFormAssessmentTeamSummary)
      .catch(this.errorHandler);
  }

  deleteAssessmentTeamSummary(id) {
    return this._http.delete(this._baseUrl + "api/FormAssessmentTeamSummary" + id)
      .map((response: IFormAssessmentTeamSummary) => response as IFormAssessmentTeamSummary)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


